import { render, staticRenderFns } from "./AppliedFilterChips.vue?vue&type=template&id=2ff63900"
import script from "./AppliedFilterChips.vue?vue&type=script&lang=js"
export * from "./AppliedFilterChips.vue?vue&type=script&lang=js"
import style0 from "./AppliedFilterChips.vue?vue&type=style&index=0&id=2ff63900&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports